<template>
  <div
    v-if="parent_data"
    class="el-select"
    :class="{ 'can-change': is_editable, dense: dense }"
  >
    <div v-if="label" class="question-label">
      <div>
        {{ label }}
      </div>
      <div>
        <slot />
      </div>
    </div>
    <span class="question-value">
      <q-select
        v-if="is_editable"
        :options="options"
        :dense="dense"
        v-model="selectValue"
        outlined
        :borderless="!is_editable"
        emit-value
      />
      <span v-else>
        {{ selectValue.label }}
      </span>
    </span>
  </div>
</template>

<script>
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

export default {
	name: "el-select",
	mixins: [ElementMixin],
	props: {
		label: {
			type: String,
			default: "",
		},
		options: {
			default: () => [],
			type: Array,
		},
		dense: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		selectValue: {
			get () {
				return this.options.find(option => typeof option.value !== "undefined" ? option.value == this.value : option == this.value);
			},
			set (item) {
				this.edit_study(item);
			},
		},
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app';
@import '../../../../assets/css/page';

.el-closed-question {
  padding: 4px 16px;
  margin-bottom: 4px;
  min-height: 40px;
  background-color: #eee;
  border-radius: radius;
  display: flex;
  align-items: center;

  &.dense {
    min-height: 34px;
  }

  &.can-change {
    cursor: pointer;
    box-shadow: 0 0 0 1px purple;
    background-color: lighten(purple, 85%);

    &:hover {
      background-color: alpha(purple, 20%);
    }
  }

  .question-label {
    display: block;
    width: 100%;
    padding-right: 48px;
  }

  .question-value {
    // height 24px
  }
}
</style>